module.exports = __webpack_public_path__ + "img/mtablet.8149d150.png";